import wordmark from '../assets/wordmark-ink.png';

/** Veerenstael wordmark (ink tone). */
export function Logo({ height = 28 }: { height?: number }) {
  return (
    <img
      src={wordmark}
      alt="Veerenstael"
      height={height}
      style={{ display: 'block', height, width: 'auto' }}
    />
  );
}
